import { DataLabelingProjectModel } from "../services/ProjectService";

export class CommonLibrary{

  public ProjectId: number;
  public ActiveProject: DataLabelingProjectModel;
  public InlineEdit: boolean;
  public LockedPreAnnotatedEntity: boolean;
  public ShowSourceTypeFilter: boolean;
  public ShowDocumentChangedBadge: boolean;
  public UserProjects: any[];
  public ForceDefaultAnnotationStatus: boolean;
  public ShowCountryFilter: boolean;
  public ShowUniqueIdFilter: boolean;
  public DashboardPeriodPersistence: boolean;

  get GetProjectId () {
    return parseInt(localStorage.getItem("projectId") || "0");
  };
  get GetEditMode(){
    return this.GetActiveProject.InlineEditMode;
  };
  get GetLockedPreAnnotatedEntity(){
    return this.GetActiveProject.LockedPreAnnotatedEntity;
  };
  get GetShowSourceTypeFilter(){
    return this.GetActiveProject.ShowSourceTypeFilter;
  };
  get GetShowDocumentChangedBadge(){
    return this.GetActiveProject.ShowDocumentChangedBadge;
  }
  get GetUserProjects(){
    const projects = sessionStorage.getItem("projects");
    return projects ? JSON.parse(projects) : [];
  };
  get GetForceDefaultAnnotationStatus(){
    return this.GetActiveProject.ForceDefaultAnnotationStatus;
  }
  get GetShowCountryFilter(){
    return this.GetActiveProject.ShowCountryFilter;
  }
  get GetShowUniqueIdFilter(){
    return this.GetActiveProject.ShowUniqueIdFilter;
  }
  get GetDashboardPeriodPersistence(){
    return this.GetActiveProject.DashboardPeriodPersistence;
  }

  get GetActiveProject(){
    const project = sessionStorage.getItem("activeProject");
    return project ? JSON.parse(project) : {};
  }

  public constructor() {
    this.ProjectId = parseInt(localStorage.getItem("projectId") || "0");
    this.ActiveProject = JSON.parse(sessionStorage.getItem("activeProject") || "{}");
    this.InlineEdit = this.ActiveProject.InlineEditMode;
    this.LockedPreAnnotatedEntity = this.ActiveProject.LockedPreAnnotatedEntity;
    this.ShowSourceTypeFilter = this.ActiveProject.ShowSourceTypeFilter;
    this.ShowDocumentChangedBadge = this.ActiveProject.ShowDocumentChangedBadge;
    this.UserProjects = JSON.parse(sessionStorage.getItem("projects") || "[]");
    this.ForceDefaultAnnotationStatus = this.ActiveProject.ForceDefaultAnnotationStatus;
    this.ShowCountryFilter = this.ActiveProject.ShowCountryFilter;
    this.ShowUniqueIdFilter = this.ActiveProject.ShowUniqueIdFilter;
    this.DashboardPeriodPersistence = this.ActiveProject.DashboardPeriodPersistence;
  }



  
  
  
};
